import Arbor from '../../arbor'

export default function replaceNavigation(step) {

    if (Arbor.store('qv').navigation.hasInlineWebForm && Arbor.store('qv').navigation.shouldInlineWithRedirect) {
        return step === 2
    }

    if (Arbor.store('qv').navigation.hasInlineWebForm) {
        return false
    }

    return step === 1

}
